import React, {Component} from 'react'
import PropTypes from 'prop-types'
import PDF from 'react-pdf-js'
import Pagination from "./Pagination"
import './style.css'


const ActionsEnum = {
    BACK: 1,
    NEXT: 2,
    INCREASE: 'increase',
    DECREASE: 'decrease',
}

class MCEadContentPDF extends Component {

    state = {
        pages: 0,
        currentPage: 1,
        scale: 1,
    }


    componentDidMount() {
        document.addEventListener("keydown", this.onKeyDown)
    }


    componentWillUnmount() {
        document.removeEventListener("keydown", this.onKeyDown)
    }


    onKeyDown = ({key}) => {
        if (key === '+')
            this.handleScaleChange(ActionsEnum.INCREASE)
        else if (key === '-')
            this.handleScaleChange(ActionsEnum.DECREASE)
    }


    componentWillReceiveProps({page}) {
        if (page) this.setState({currentPage: page});
    }


    handleChangePage = (action) => {

        if (action === ActionsEnum.BACK) {

            if (this.state.currentPage === 1)
                return

            this.setState({
                currentPage: this.state.currentPage - 1
            })
        } else if (action === ActionsEnum.NEXT) {

            if (this.state.currentPage === this.state.pages)
                return

            this.setState({
                currentPage: this.state.currentPage + 1
            })
        }
    }


    handleScaleChange(action) {

        if (action === ActionsEnum.INCREASE) {

            if (this.state.scale === 3)
                return

            this.setState({scale: this.state.scale + 0.5})

        } else if (action === ActionsEnum.DECREASE) {
            if (this.state.scale === 1)
                return

            this.setState({scale: this.state.scale - 0.5})
        }
    }


    handleDocumentComplete = (pages) => {
        this.setState({pages})
    }


    render() {
        const {url} = this.props

        const {pages, currentPage, scale} = this.state

        return (
            <div className={'mc-ead-content-pdf'}>
                <div style={{
                    overflowY: 'auto',
                    flex:1 ,
                    padding: '1rem .5rem 6rem .5rem',
                    textAlign:'center',
                    width: '100%',
                }}>
                    <PDF
                        file={url}
                        page={currentPage}
                        scale={scale}
                        onDocumentComplete={this.handleDocumentComplete}
                        {...this.props}
                    />


                </div>



                    <Pagination totalPages={pages}
                                currentPage={currentPage}
                                onScaleChange={(act) => this.handleScaleChange(act)}
                                onPageChange={(act) => this.handleChangePage(act)}/>

            </div>
        )
    }
}


MCEadContentPDF.propTypes = {
    url: PropTypes.string.isRequired,
}

MCEadContentPDF.defaultProps = {}

export default MCEadContentPDF



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/PDF/index.js